import React from "react";
import styles from "./ComponentCard.module.css";
import { selectPrice } from "../../utils/priceHelpers.ts";
import { useIsB2B } from "../../hooks/useViewModel.ts";

export interface PriceDifferenceBadgeProps {
	priceDifference: {
		net: number;
		gross: number;
	};
}

export const PriceDifferenceBadge: React.FC<PriceDifferenceBadgeProps> = ({
	priceDifference,
}) => {
	const isB2B = useIsB2B();
	const price = selectPrice(priceDifference, isB2B);
	const isPositive = price > 0;
	const isNegative = price < 0;
	const formattedPrice =
		new Intl.NumberFormat("nb-NO", {
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		}).format(Math.abs(price)) + ",-";

	const displayText = isPositive
		? `+ ${formattedPrice}`
		: isNegative
			? `- ${formattedPrice}`
			: formattedPrice;

	const ariaLabel = isPositive
		? `Prisdifferanse: +${formattedPrice}`
		: isNegative
			? `Prisdifferanse: -${formattedPrice}`
			: `Prisdifferanse: ${formattedPrice}`;

	return (
		<div className={styles.priceDifferenceBadge} aria-label={ariaLabel}>
			{displayText}
		</div>
	);
};